import { Switch } from "@progress/kendo-react-inputs"
import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks"
import { editCaseManDocumentRequest } from "../../../../../services/caseManService/model/caseMan/CaseManagementSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";

function ClinicalRecordsRequest(){
    const dispatch = useAppDispatch();
    const caseMan = useAppSelector((state) => state.caseManagement.caseManagement);

    return <React.Fragment>
        <div>
            <label>Clinical Records</label><br/>
            <Switch value={caseMan.documentRequest?.clinicalRecord} 
                checked={caseMan.documentRequest?.clinicalRecord}
                onChange={(e)=>dispatch(editCaseManDocumentRequest(new ReduxUpdate('clinicalRecord',e.target.value)))}/>
        </div>
    </React.Fragment>
}
export {ClinicalRecordsRequest}